import { List } from "models/list";
import { doGet } from "services/request";

export const userDoGetList = async (listUuid: string) => {
  const list = await doGet<List>(`/user/list/${listUuid}`);
  return list;
};
